import { LoadingButton } from '@mui/lab';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { FormEvent, useState } from 'react';
import { EscHotKeyIcon, ReturnHotKeyIcon } from '../HotKeyIcons';

interface ArtefactRenameProps {
  artefactType: 'search' | 'quantify';
  initialValue: string;
  onClose: () => void;
  onSubmit: (name: string) => void;
}

export const ArtefactRename = ({
  artefactType,
  initialValue,
  onSubmit,
  onClose,
}: ArtefactRenameProps) => {
  const [name, setName] = useState(initialValue);
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
    setDisabled(event.target.value === '');
  };

  const handleClose = () => {
    onClose();
  };

  const onArtefactRename = (e: FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    onSubmit(name);
  };

  return (
    <Box p={3}>
      <Stack spacing={4} component="form" onSubmit={onArtefactRename}>
        <Typography id="modal-modal-title" variant="h6" color="primary.main">
          Rename {capitalize(artefactType)}
        </Typography>
        <Typography id="modal-modal-description">
          <Stack gap={3}>
            <TextField
              value={name}
              placeholder={`Enter descriptive ${capitalize(artefactType)} name`}
              variant="outlined"
              label={`${capitalize(artefactType)} Name`}
              onChange={handleChange}
              fullWidth
              required
              disabled={isLoading}
            />
            <Stack direction="row" gap={3} justifyContent="right">
              <Button
                variant="outlined"
                onClick={handleClose}
                endIcon={<EscHotKeyIcon />}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                disabled={disabled}
                loading={isLoading}
                type="submit"
                endIcon={<ReturnHotKeyIcon isDisabled={disabled} />}
              >
                Rename
              </LoadingButton>
            </Stack>
          </Stack>
        </Typography>
      </Stack>
    </Box>
  );
};
